<template>
  <div id="OrderList" ref="OrderList" :class="sellOrderType == 2 ? 'order_min_w' : ''" :style="{ 'height': screenHeight + 'px' }">
    <div class="order_list_detail" v-for="(item, index) in list" :key="index">
      <div class="order_detail_box">
        <div class="od_left">
          <span>{{ item.CreateDate ? $store.getters.getTime(item.CreateDate, $store.state.lang.indexOf("zh") > -1 ? 8 : -8) : '' }}</span>
          <!-- OrderStatus：{{ item.OrderStatus }} — sellOrderType：{{ sellOrderType }}， -->
          <span>{{ $t('enum.orderNumber') }} :<em>{{ item.Code }}</em></span>
          <span class="img">
            <em @click="blackUserDialog(item)"><el-avatar class="user_img" style="margin:12px 4px 0 0;" :src="item.HeadPortrait + $store.state.thumbnail"></el-avatar></em>
            &nbsp;&nbsp;
            <a class="btns" target="_blank" :href="`${$store.getters.CHAT(item.ReceiveUserID)}&type=${$store.state.Chat.OrderType}&id=${item.ID}`">
              {{ item.RealName }}
              <i class="member_source" v-if="item.BuyerMemberSource == 'CN'">{{ item.BuyerMemberSource }}</i>
            </a>&nbsp;({{ parseInt(item.BuyerIntegral) }})
          </span>
        </div>
        <div class="od_right">
          <!-- CountDown:{{ item.CountDown }}，  OrderStatus:{{item.OrderStatus }}， CountDownType:{{ item.CountDownType }} -->
          <span v-if="item.CountDown > 0 && item.OrderStatus == 1" class="text_red"><i class="el-icon-time"></i>
            {{ item.CountDownType == 1 ? $t('enum.remaining') : $t('enum.autoClosed') }}: {{ timeCountDown(item.CountDown) }}
          </span>
        </div>
      </div>
      <div class="flex order_list">
        <div class="card_detail_box">
          <div class="card_detail" v-for="(obj, k) in item.Details" :key="k">
            <div class="cd_info com_box order-title" style="width:88px;" @click="dialogBox('ViewDetails', item)">
              <el-image class="like_img" :src="obj.TitImg && obj.TitImg != '没有可上传的图片' ? obj.TitImg + $store.state.thumbnail : '/static/images/noimg.svg'" fit="contain">
              </el-image>
            </div>
            <div class="cd_info com_box order-title" style="min-width:200px;flex: 1;" @click="dialogBox('ViewDetails', item)">
              <p style="word-break: break-word;display: -webkit-box;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;-webkit-line-clamp: 3;">
                {{ $store.getters.setTitle(obj.Title, 'all') }}</p>
            </div>
            <div class="cd_info align_r">
              <!-- 单价 -->
              <div>USD {{ item.USDRate ? $store.getters.thousandAndDecimal((obj.Price * item.USDRate).toFixed(2)) : '' }}</div>
            </div>
            <div class="cd_info shipment align_r">
              <div v-if="k == 0">
                <!-- 运费 -->
                <div>{{ ['paid on delivery', '到付', 'pay on delivery', '顺丰到付'].includes(item.NewPostageMoney.toLowerCase()) ? $t('newItem.payOnDelivery') : (item.USDRate ? 'USD ' + $store.getters.thousandAndDecimal((item.PostageMoney * item.USDRate).toFixed(2)) : '') }}</div>
                <div class="text_gray" v-if="item['Details'].length > 1">for {{ item['Details'].length }} Items</div>
              </div>
              <div v-else>&nbsp;</div>
            </div>
            <div class="cd_info align_r">
              <div v-if="k == 0">
                <!-- 总价 -->
                <div class="PostageMoney">
                  USD
                  {{ $store.getters.thousandAndDecimal(itemPriceTotle(item)) }}
                </div>
                <!-- <div class="text_blue">{{obj.AuctionCount}} {{obj.AuctionCount>1 ? 'Bids':'Bid'}}</div> -->
                <router-link v-if="obj.ByWay == 2" class="underline hover" :to="{ path: '/commodity/Active/VctiveHstory/' + obj.ID }">
                  {{ obj.AuctionCount }} {{ obj.AuctionCount != 1 ? $t('enum.bids') : $t('enum.bid') }}
                </router-link>
              </div>
              <div v-else>&nbsp;</div>
            </div>
            <div class="cd_info align_r" v-if="sellOrderType == 6">
              <!-- 订单已完成【状态】 -->
              <!-- OrderStatus：4（已完成、未评价），5（已完成、已评价），6（交易关闭） -->
              <div :class="item.OrderStatus == 6 ? 'text_gray' : 'text_greed'">
                {{ item.OrderStatus == 6 ? $t('status.closed') : $t('status.completed') }}
              </div>
            </div>
            <div class="cd_info align_r" v-if="sellOrderType == 0 || sellOrderType == 2">
              <!-- <div v-if="sellOrderType == 0">{{ tabList[item.OrderStatus]['label'] }}</div> -->
              <div v-if="k == 0" :class="endingTime(item.PayDate) != '00:00:00' || !item.PayDate ? '' : 'text_red'">{{ item.PayDate && item.OrderStatus == 2 ? endingTime(item.PayDate) : '' }}</div>
              <div v-else>&nbsp;</div>
            </div>
            <div class="cd_info" style="width:148px;text-align: center;padding:0;">
              <div v-if="k == 0">
                <!-- 操作栏 -->
                <!-- SRType：是否维权 0 未开启维权，其他已开启维权 -->
                <!-- ## To be paid 待付款 ## -->
                <div class="operate order_operate" v-if="sellOrderType == 1 || (sellOrderType == 0 && [1].indexOf(item.OrderStatus) > -1 && item.SRType == 0)">
                  <!-- <div class="btns text_blue" @click="dialogBox('ContactBuyer',item)">Contact Buyer</div> -->
                  <div>
                    <a class="btns" target="_blank" :href="`${$store.getters.CHAT(item.ReceiveUserID)}&type=${$store.state.Chat.OrderType}&id=${item.ID}`">
                      <span class="hover underline">{{ $t('button.contactBuyer') }}</span>
                    </a>
                    <!-- <router-link class="btns text_blue" target="_blank" :to="`/contact?oid=${item.ID}`">Contact Buyer</router-link> -->
                  </div>
                  <div class="btns" @click="dialogBox('EditShippingFee', item)">{{ $t('button.editShippingFee') }}</div>

                  <!-- <div class="btns" @click="dialogBox('ContactCardHobby',item)">Contact Card Hobby</div>-->
                  <div>
                    <a class="btns" target="_blank" :href="`${$store.getters.CHAT('admin')}&type=${$store.state.Chat.OrderType}&id=${item.ID}`">
                      <span class="hover underline">{{ $t('button.contactCardHobby') }}</span>
                    </a>
                    <!-- <router-link class="btns" target="_blank" :to="`/contact?oid=${item.ID}&type=cch`">Contact Card Hobby</router-link> -->
                  </div>
                  <!-- <div class="btns" @click="dialogBox('Processing', item)">{{ item.SRType == 0 ? 'Open case' : 'View Case Detail' }}</div> -->
                  <div v-if="item.MergeState == 1" class="btns hover underline" @click="dialogBox('MergeOrders', item)">{{ $t('button.mergeOrders') }}</div>
                  <div v-if="item.MergeState == 2" class="btns hover underline" @click="dialogBox('RestoreOrder', item)">{{ $t('button.splitOrders') }}</div>
                  <!--  CountDown：倒计时秒数 259200 //72小时
                  CountDownType：倒计时类型 待支付状态可能出现的状态：
                  待支付状态=1, 鸽子待支付状态=2, 卖家可关闭状态=3,系统自动关闭=4,系统再次自动关闭=5,
                  待收货状态可能出现的状态：系统自动收货 = 6 -->
                  <div v-if="item.CountDown != 0 && [3].indexOf(item['CountDownType']) > -1" :class="['btns', 'hover', 'underline', item['CountDownType'] == 2 ? 'text_gray' : '']" @click="dialogBox('CloseOrder', item)">
                    {{ $t('button.closeOrder') }}
                  </div>

                  <!-- <div class="btns" @click="dialogBox('Appeal',item)">Appeal</div> -->
                </div>
                <!-- ## Shipping 待发货 ## -->
                <div class="operate order_operate" v-else-if="sellOrderType == 2 || (sellOrderType == 0 && [2].indexOf(item.OrderStatus) > -1 && item.SRType == 0)">
                  <div class="btns hover underline" @click="dialogBox('Ship', item)">{{ $t('button.ship') }}</div>
                  <div>
                    <a class="btns" target="_blank" :href="`${$store.getters.CHAT(item.ReceiveUserID)}&type=${$store.state.Chat.OrderType}&id=${item.ID}`">
                      <span class="hover underline">{{ $t('button.contactBuyer') }}</span>
                    </a>
                  </div>
                </div>
                <!-- ## Shipped 待收货 ##-->
                <div class="operate order_operate" v-else-if="sellOrderType == 3 || (sellOrderType == 0 && [3].indexOf(item.OrderStatus) > -1 && item.SRType == 0)">
                  <div v-if="item.CheckTimeLong && item.CheckTimeLong > 0" class="CheckTimeLong text_red">
                    <!-- 跨境订单验证后自动收货倒计时 -->
                    {{ timeCountDown(item.CheckTimeLong) }}
                  </div>
                  <div>
                    <a class="btns" target="_blank" :href="`${$store.getters.CHAT(item.ReceiveUserID)}&type=${$store.state.Chat.OrderType}&id=${item.ID}`">
                      <span class="hover underline">{{ $t('button.contactBuyer') }}</span>
                    </a>
                  </div>

                  <div class="btns" v-if="item.CheckState == -1" @click="dialogBox('ChangeShippingInfo', item)">
                    {{ $t('button.modifyShippingInfo') }}
                  </div>
                  <!-- View Photos 跨境订单（平台验收）【自定义地址不显示按钮】-->
                  <div class="btns" @click="dialogBox('ViewPhotos', item)" v-if="item.BusinessType == 2 && !item.IsCustomAdress">{{ $t('button.viewPhotos') }}</div>
                  <div class="btns" @click="dialogBox('Processing', item)" v-if="item.SRType != 0">{{ item.SRType == 0 ? $t('button.opencase') : $t('button.viewCaseDetail') }}</div>
                </div>
                <!-- ## Processing 维权中 ## -->
                <div class="operate order_operate" v-else-if="sellOrderType == 4 || (sellOrderType == 0 && [2, 3, 4, 5].indexOf(item.OrderStatus) > -1 && item.SRType != 0)">
                  <div class="btns hover underline" @click="dialogBox('ViewDetails', item)">{{ $t('button.viewDetails') }}</div>
                  <!-- View return info 跨境订单 -->
                  <!-- <div class="btns" @click="dialogBox('ViewReturnInfo',item)">View Return Info</div> 现阶段隐藏20230207 -->
                  <div class="btns" @click="dialogBox('Processing', item)">{{ item.SRType == 0 ? $t('button.opencase') : $t('button.viewCaseDetail') }}</div>
                </div>
                <!-- ## To be Reviewed 待评价 ## -->
                <div class="operate order_operate" v-else-if="sellOrderType == 5 || (sellOrderType == 0 && [4].indexOf(item.OrderStatus) > -1 && item.SRType == 0)">
                  <div class="btns hover underline" @click="dialogBox('ToBeReviewed', item)">{{ $t('button.leaveFeedback') }}</div>
                  <!-- <div class="btns" v-if="item.IsAppraisal" @click="dialogBox('FeedbackDetail',item)">Feedback Left</div> -->
                </div>
                <!-- ## Finished 已完成 ## -->
                <div class="operate order_operate" v-else-if="(sellOrderType == 6 || sellOrderType == 8) || (sellOrderType == 0 && [5, 6].indexOf(item.OrderStatus) > -1 && item.SRType == 0)">
                  <div class="btns hover underline" @click="dialogBox('ViewDetails', item)">{{ $t('button.viewDetails') }}</div>
                  <div class="btns hover underline" v-if="item.OrderStatus == 4" @click="dialogBox('ToBeReviewed', item)">
                    {{ $t('button.leaveFeedback') }}
                  </div>
                  <div class="btns" @click="dialogBox('ViewPhotos', item)" v-if="item.BusinessType == 2 && !item.IsCustomAdress">{{ $t('button.viewPhotos') }}</div>
                  <!-- 开启鸽子订单 -->
                  <div v-if="item['OpenState'] == 1" class="btns hover underline" @click="getData('OpenOrder', item, { 'OrderID': item.ID })">
                    {{ $t('button.orderReopened') }}
                  </div>
                  <!-- 查看评价详情【暂无】 -->
                  <!-- <div class="btns hover underline" v-else @click="dialogBox('MyFeedback',item)">My Feedback</div> -->
                </div>
                <!-- /操作栏ed -->
              </div>
              <div v-else>&nbsp;</div>
            </div>

          </div>
        </div>

      </div>

    </div>
    <dialog-order v-if="orderOfferShow" ref="DialogOrder" @dialogBox="dialogBox" :dialogTitle="dialogTitle" @DialogSwitch="DialogSwitch">
    </dialog-order>
    <dialog-offer v-if="OfferShow" ref="DialogOffer" :OfferTitle="OfferTitle" :OfferList="OfferList" @OfferBox="OfferBox" @DialogSwitch="DialogSwitch">
    </dialog-offer>
    <!-- #region 黑名单-拉黑用户 -->
    <el-dialog :title="`${$t('button.block')} ${blackItem.RealName||''}?`" :visible.sync="dialogBlackVisible" @close="dialogBlackVisible = false;blackItem = {}">
      <div style="padding: 20px">{{ $t('enum.blockTips') }}</div>
      <div slot="footer">
        <el-button @click="dialogBlackVisible = false;blackItem = {}">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="blackUser(blackItem)">{{ $t('button.block') }}</el-button>
      </div>
    </el-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import DialogOrder from '@/components/dialog/dialog-order'
import DialogOffer from '@/components/dialog/dialog-offer'
export default {
  name: 'orderlist',
  data() {
    return {
      timer: "",
      nowData: new Date().getTime(),
      OfferShow: false,//DialogOffer
      orderOfferShow: false,
      dialogBlackVisible: false,//拉黑用户
      blackItem: {},//拉黑用户信息
      OfferList: [],
      OfferTitle: '',
      sellOrderType: 1,
      dialogTitle: '',
      wyimLink: `${this.$store.getters.CHAT()}`,
      screenHeight: 200,
      titleWidth: 0,
      timeLeng: 0,//秒倒计时累加
    }
  },
  props: {
    tabList: [],
    list: [],
    tabname: "",
    showType: String,
    refresh: {},
  },
  components: { DialogOrder, DialogOffer },
  created() {
    this.cardTimer();
    this.tabHeight();
  },
  mounted() {
    // console.log(this.list)
    this.getWidth();
    window.addEventListener('resize', () => {
      this.tabHeight()
    })
  },
  computed: {
    itemPriceTotle() {
      return function (item) {
        var PostageMoney = item.PostageMoney * item.USDRate;
        var price = 0;
        // console.log("itemPriceTotle", item);
        item['Details'].map((obj, k) => {
          price += obj.Price * item.USDRate;
        });
        price = (price + PostageMoney).toFixed(2);
        return price;
      };
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getData(api, obj, params) {
      let that = this;
      var fun = "";
      switch (api) {
        case 'OpenOrder'://鸽子订单重新开启
          fun = function (res) {
            if (res.result) {
              that.$message({
                showClose: true,
                message: res.msg || 'Successful',
                type: "success",
              });
              that.$emit('MsgTabs', 1, 'To be paid')
            } else {
              // let Msg = res.msg || 'Edit Shipping Fee failed';
              // that.$message.error(Msg);
            }
          };
          break;
      }
      that.$post(api, params)
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 弹框标题
    dialogBox(type, obj) {
      /*  */
      let that = this;
      // console.log('CardInfo:', obj);
      switch (type) {
        case 'ContactBuyer'://联系买家
          that.dialogTitle = this.$t('button.contactBuyer');
          break;
        case 'Ship'://填写运输信息
          that.dialogTitle = this.$t('button.ship');
          //that..... 获取快递列表
          break;
        case 'CloseOrder'://关闭订单
          that.dialogTitle = this.$t('button.closeOrder');
          if (obj.CountDownType == 2) {
            //鸽子待支付状态
            return false;
          }
          break;
        case 'MergeOrders'://合并订单
          that.dialogTitle = this.$t('button.mergeOrders');
          // that.$r({name: 'orders-merge'})
          window.location.href = `/#/orders/merge?uid=${obj.ReceiveUserID}&oid=${obj.ID}`;
          return false;
          break;
        case 'RestoreOrder'://拆分订单
          that.dialogTitle = this.$t('enum.splitOrders');
          break;
        case 'ChangeShippingInfo'://修改运输信息
          that.dialogTitle = this.$t('button.modifyShippingInfo');
          //that..... 获取快递列表
          break;
        case 'ViewReturnInfo'://查看退货信息
          that.dialogTitle = this.$t('button.returnShippingInfo');
          break;
        case 'ViewDetails'://查看订单详细 
          that.dialogTitle = "Card Details";
          window.open(`/#/orders/detail?id=${obj.ID}`);
          return false;
          break;
        case 'Processing'://查看维权详细 
          that.OfferBox('Processing', obj);
          return false;
          break;
        case 'ViewPhotos'://查看跨境订单信息
          that.dialogTitle = this.$t('button.cardDescription');
          break;
        case 'EditShippingFee'://修改运费
          that.dialogTitle = this.$t('button.editShippingFee');
          break;
        case 'ContactCardHobby'://申诉
          that.dialogTitle = this.$t('button.contactCardHobby');
          break;
        case 'ToBeReviewed'://评论
          that.dialogTitle = this.$t('button.leaveFeedback');
          break;
        case 'FeedbackDetail'://查看评论
          that.dialogTitle = this.$t('button.feedbackDetail');
          break;
        default:
          break;
      }
      that.getOrderDetail(obj, type);
    },
    blackUserDialog(obj) {
      console.log("blackUserDialog", obj);
      //用户拉黑
      let that = this;
      that.blackItem = obj;
      that.dialogBlackVisible = true;
    },
    blackUser(obj) {
      let that = this;
      that.$post('OperateBlack', { TargetId: parseInt(obj.BuyerWyAccId),Type:1,mbname:'web' }) //拉黑用户
        .then((res) => {
          if (res.result) {
            that.$message({
              showClose: true,
              message: res.msg || 'Successful',
              type: "success",
            });
            that.dialogBlackVisible = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取维权的申诉列表
    OfferBox(type, obj) {
      let that = this;
      switch (type) {
        case 'Processing':
          /* 维权 */
          that.$get('GetSafeRights', `?orderId=${obj.ID}&pageIndex=1&pageSize=999&applyType=0`)// 维权列表
            .then((res) => {
              if (res.result) {
                let _data = res.data;
                _data['objs'] = _data['objs'].reverse();
                if (obj.HeadPortrait) {
                  _data['HeadPortrait'] = obj.HeadPortrait;
                }
                that.$get('OrderDetail', `?OrderID=${obj.ID}`)//订单详情
                  .then((ress) => {
                    that.OfferShow = true;
                    setTimeout(() => {
                      that.OfferTitle = obj.SRType == 0 ? this.$t('button.opencase') : (_data.SRStatus == 1 ? this.$t('enum.disputing') + '...' : this.$t('enum.disputed'));//维权状态
                      that.$refs.DialogOffer.CardInfo = _data;
                      that.$refs.DialogOffer.ID = obj.ID;
                      if (ress.result) {
                        that.$refs.DialogOffer.CardInfo['OrderDetail'] = ress.data;
                      }
                      that.$refs.DialogOffer.dialogType = type;
                      that.$refs.DialogOffer.OfferShow = true;
                    }, 200)
                  })
              }
            })
            .catch((err) => {
              console.log(err);
            });
          that.OfferList = [];
        default:
          that.OfferShow = true;
          setTimeout(() => {
            that.$refs.DialogOffer.OfferShow = true;
            that.$refs.DialogOffer.dialogType = type;
          }, 100)
          break;
      }
    },
    // 获取订单详情列表
    getOrderDetail(obj, type) {
      let that = this;
      //CommodityID
      that.$get('OrderDetail', `?OrderID=${obj.ID}`)//订单详情
        .then((res) => {
          that.orderOfferShow = true;
          if (type == 'FeedbackDetail') {
            //评论详细
            that.$get('AppraisalList', `?orderId=${obj.ID}&pageIndex=1&pageSize=999&AppraisalStatus=0`) //评价历史
              .then((res) => {
                if (res.result) {
                  //// 评论历史列表
                  that.$refs.DialogOrder.AppraisalList = res.data;
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (type == 'ViewPhotos') {
            //订单验收详情
            that.$get('GetOrderCheck', `?orderId=${obj.ID}`)
              .then((res) => {
                if (res.result) {
                  var _data = res.data
                  var val = []
                  if (_data['data'].length > 0) {
                    _data['data'].map((obj, k) => {
                      val.push(obj.ImgUrl)
                    });
                  }
                  that.$refs.DialogOrder.previewImgList = val
                  that.$refs.DialogOrder.OrderCheck = _data;
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
          console.log("CardInfo", obj);
          setTimeout(() => {
            if (res.result) {
              that.$refs.DialogOrder.CardInfo = res.data;
            } else {
              that.$refs.DialogOrder.CardInfo = obj;
            }
            that.$refs.DialogOrder.dialogType = type;
            that.$refs.DialogOrder.DialogShow = true;
          }, 100)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setOfferTitle(val) {
      this.OfferTitle = val || 'Detail';
    },
    // 关闭弹框
    DialogSwitch(dialog) {
      /* dialog Close */
      if (this.$refs.DialogOrder) {
        this.$refs.DialogOrder.DialogShow = false;
      }
      if (this.$refs.DialogOffer) {
        this.$refs.DialogOffer.OfferShow = false;
      }
      this.OfferShow = false;
      this.orderOfferShow = false;
    },
    // 获取卖家订单列表
    getList() {
      this.$parent.getData();
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
        this.timeLeng++;
      }, 1000);
    },
    // 倒计时
    endingTime(time) {
      let newval = this.$store.getters.setUTC(this.nowData, -8)
      return this.$store.getters.endingTime(time, 24)
    },
    // 秒倒计时
    timeCountDown(time) {
      time -= this.timeLeng;
      var res = "00:00";
      if (time >= 0) {
        res = this.$store.getters.timeCountDown(time);
      }
      if (res == "00:00") {
        this.$emit('MsgTabs', this.sellOrderType, this.tabname)
      }
      return res
    },
    // 获取order_title 长度
    getWidth() {
      let tabwidth = this.$refs.OrderList.offsetWidth == '1108' ? this.$refs.OrderList.offsetWidth : this.$refs.OrderList.offsetWidth + 15;
      this.titleWidth = tabwidth
      // this.$emit('refresh', this.titleWidth)
    },
    // 获取list固定长度
    tabHeight() {
      this.screenHeight = document.body.clientHeight;
      let Sheight = this.screenHeight - 70 - 50 - 35 - 55 - 45 - 20 - 120 - 15 - 15 + 75 - 55
      this.$nextTick(() => {
        // console.log(Sheight );
        this.screenHeight = Sheight
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/orderlist.css";
</style>



// WEBPACK FOOTER //
// src/components/orderlist.vue